import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { MyDomain } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Autocomplete, Paper } from "@mui/material";
import { styled } from "@mui/system";
import CloseImg from "../../Images/CloseImg.png";
import { Popover, Modal, Carousel, Empty } from "antd";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";

const StyledPaper = styled(Paper)({
  maxHeight: "380px", // Set maximum height for the dropdown
  overflowY: "auto", // Enable vertical scroll
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function ProfileAddressBook() {
  const { t, i18n } = useTranslation();
  const [Towns, setTowns] = useState([]);
  const [CheckTowns, setCheckTowns] = useState([]);

  const [CountryPhoneNumbers, setCountryPhoneNumbers] = useState({
    label: "+972",
    value: "+972",
  });

  const [ArrayCountryPhoneNumbers, setArrayCountryPhoneNumbers] = useState([
    { label: "+972", value: "+972" },
  ]);
  const GetTowns = () => {
    axios
      .get(`${MyDomain}Towns/GetAllTowns`) // Replace with your API endpoint
      .then((response) => {
        setCheckTowns(response.data);
        const newArray = response.data.map((item) => ({
          label: item.town,
          value: item.town,
        }));
        setTowns(newArray);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
        setError(err.response.data); // Handle any errors
      });
  };
  useEffect(() => {
    GetTowns();
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {}, []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const GetAddresses = () => {
    const data = {
      UserId: user?.userId,
    };
    // Fetch data when the component mounts
    axios
      .post(`${MyDomain}Addresses/GetAddressesByUserId`, data) // Replace with your API endpoint
      .then((response) => {
        setData(response.data); // Store the data
        setLoading(false); // Set loading to false
        console.log(response.data);
        setSelectedUserId(String(response.data[0].choosing));
      })
      .catch((err) => {
        console.log(err.response.data);
        setError(err.response.data); // Handle any errors
        setLoading(false);
      });
  };
  useEffect(() => {
    GetAddresses();
  }, []); // Empty dependency array ensures this effect runs once on mount

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [FirstName, setFirstName] = useState(user.firstName);
  const [FirstNameError, setFirstNameError] = useState(false);

  const [LastName, setLastName] = useState(user.lastName);
  const [LastNameError, setLastNameError] = useState(false);

  const [PhoneNumber, setPhoneNumber] = useState(""); //user.phoneNumber
  const [PhoneNumberError, setPhoneNumberError] = useState(false);

  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const [Direction, setDirection] = useState("");

  const [City, setCity] = useState(null);
  const [CityError, setCityError] = useState(false);

  const [Street, setStreet] = useState("");
  const [StreetError, setStreetError] = useState(false);

  const [Building, setBuilding] = useState("");
  const [Apt, setApt] = useState("");
  const [ZIPCode, setZIPCode] = useState("");

  const [IdOfDeleteAddress, setIdOfDeleteAddress] = useState("");
  const [ChooseIDForEdit, setChooseIDForEdit] = useState(0);

  const [ChooseDirection, setChooseDirection] = useState({
    label: "All Districts",
    value: "All Districts",
  });

  const TheDirection = [
    { label: "All Districts", value: "All Districts" },
    { label: "Northern District", value: "Northern District" },
    { label: "Southern District", value: "Southern District" },
    { label: "Jerusalem District", value: "Jerusalem District" },
    { label: "Southern Triangle", value: "Southern Triangle" },
    { label: "Northern Triangle", value: "Northern Triangle" },
    { label: "Haifa and Carmel region", value: "Haifa and Carmel region" },
  ];
  const CreateNewAddress = () => {
    if (
      FirstNameCreate === "" ||
      LastNameCreate === "" ||
      CountryPhoneNumberCreate === null ||
      PhoneNumberCreate === "" ||
      CityCreate === null ||
      // StreetCreate === "" ||
      // ZIPCodeCreate === "" ||
      DirectionCreate === ""
    ) {
      setUpdateFillAll(true);
      console.log("fill all");
      return;
    }
    const data = {
      UserId: user?.userId,
      FirstName: FirstNameCreate,
      LastName: LastNameCreate,
      Phonenumber: CountryPhoneNumberCreate?.value + " " + PhoneNumberCreate,
      City: CityCreate?.label,
      Street: StreetCreate,
      Building: BuildingCreate,
      Apartment: AptCreate,
      ZIPCode: ZIPCodeCreate,
      Direction: DirectionCreate,
    };
    console.log(data);
    axios
      .post(`${MyDomain}Addresses/CreateAddress`, data) // Replace with your API endpoint
      .then((response) => {
        setFirstNameCreate("");
        setLastNameCreate("");
        setCountryPhoneNumberCreate(null);
        setPhoneNumberCreate("");
        setCityCreate(null);
        setStreetCreate("");
        setBuildingCreate("");
        setAptCreate("");
        setZIPCodeCreate("");
        setDirectionCreate("");
        console.log(response.data);
        GetAddresses();
        setUpdateFillAll(false);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const DeleteAddress = async () => {
    const data = {
      id: IdOfDeleteAddress,
    };
    try {
      const response = await axios.delete(
        `${MyDomain}Addresses/DeleteAddress`,
        {
          data: { id: IdOfDeleteAddress },
        }
      );
      GetAddresses();
      setOpen1(false);
    } catch (err) {
      console.log(err.response.data);
    }
  };
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const prefix = "+972";

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Ensure the input starts with the prefix
    if (!inputValue.startsWith(prefix)) {
      inputValue = prefix;
    }

    // Extract the digits after the prefix
    let phoneDigits = inputValue.slice(prefix.length);

    // Remove extra spaces in case the user tries to add multiple spaces
    phoneDigits = phoneDigits.replace(/\s+/g, "");

    // Insert a space after the first two digits
    if (phoneDigits.length > 2) {
      phoneDigits = phoneDigits.slice(0, 2) + " " + phoneDigits.slice(2);
    }
    setPhoneNumberDataBase(prefix + phoneDigits);
    setPhoneNumber(prefix + " " + phoneDigits);
  };

  const handleFocus = () => {
    if (!PhoneNumber.startsWith(prefix)) {
      setPhoneNumber(prefix);
    }
  };
  const [selectedUserId, setSelectedUserId] = React.useState(null);

  const handleSubmit = (userId, userUserId) => {
    setSelectedUserId((prev) => (prev === userId ? null : userId));
    const data = {
      UserId: userUserId,
      Choosing: String(userId),
    };
    axios
      .put(`${MyDomain}Addresses/UpdateAddressById`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const UpdateAddressFunc = () => {
    if (
      FirstNameCreate === "" ||
      LastNameCreate === "" ||
      CountryPhoneNumberCreate === null ||
      PhoneNumberCreate === "" ||
      CityCreate === null ||
      // StreetCreate === "" ||
      // ZIPCodeCreate === "" ||
      DirectionCreate === ""
    ) {
      setUpdateFillAll(true);
      console.log("fill all");
      return;
    }
    const data = {
      Id: ChooseIDForEdit,
      UserId: user?.userId,
      FirstName: FirstNameCreate,
      LastName: LastNameCreate,
      Phonenumber: CountryPhoneNumberCreate?.value + " " + PhoneNumberCreate,
      City: CityCreate?.label,
      Street: StreetCreate,
      Building: BuildingCreate,
      Apartment: AptCreate,
      ZIPCode: ZIPCodeCreate,
      Direction: DirectionCreate,
    };
    console.log(data);
    axios
      .put(`${MyDomain}Addresses/UpdateAddress`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        GetAddresses();
        setUpdateFillAll(false);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const [open1, setOpen1] = useState(false);

  const Modal1 = () => {
    return (
      <div>
        <style>
          {`
    .ant-modal-content {
      border-radius: 0 !important;
    }
    .ant-modal {
      border-radius: 0 !important;
    }
  `}
        </style>
        <Modal
          footer={null} // This removes the default buttons
          title={
            <div
              style={{ fontSize: "24px", fontWeight: "bold", color: "#1890ff" }}
            ></div>
          }
          centered
          open={open1}
          onOk={() => setOpen1(false)}
          onCancel={() => {
            setOpen1(false);
            setIdOfDeleteAddress("");
          }}
          width="40%"
          bodyStyle={{ height: "50%", overflowY: "auto", borderRadius: "0px" }}
          style={{ borderRadius: "0px" }}
          closeIcon={
            <img
              src={CloseImg}
              //alt={title}
              style={{
                maxHeight: 22,
                maxWidth: 22,
                objectFit: "contain",
              }}
              modalRender={(node) => (
                <div style={{ borderRadius: "0px", overflow: "hidden" }}>
                  {node}
                </div>
              )}
            />
          }
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 15,
            }}
          >
            <a style={{ fontSize: 15 }}>
              {t("profile.AreyousureyouwanttodeletethisAddress")}
            </a>
            <div
              style={{
                //backgroundColor: "red",
                width: "40%",
                justifyContent: "space-evenly",
                display: "flex",
                marginTop: 20,
              }}
            >
              <button
                style={{
                  backgroundColor: "white",
                  borderWidth: 1,
                  fontSize: 15,
                  width: 60,
                  padding: 10,
                }}
                onClick={() => {
                  DeleteAddress();
                }}
              >
                <a>Yes</a>
              </button>
              <button
                style={{
                  backgroundColor: "white",
                  borderWidth: 1,
                  fontSize: 15,
                  width: 60,
                  padding: 10,
                }}
                onClick={() => {
                  setIdOfDeleteAddress("");
                  setOpen1(false);
                }}
              >
                <a>No</a>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  console.log(CountryPhoneNumbers?.value);
  console.log(PhoneNumber);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [FirstNameCreate, setFirstNameCreate] = useState("");
  const [LastNameCreate, setLastNameCreate] = useState("");
  const [CountryPhoneNumberCreate, setCountryPhoneNumberCreate] = useState({
    label: "+972",
    value: "+972",
  });
  const [PhoneNumberCreate, setPhoneNumberCreate] = useState("");
  const [CityCreate, setCityCreate] = useState(null);
  const [StreetCreate, setStreetCreate] = useState("");
  const [BuildingCreate, setBuildingCreate] = useState("");
  const [AptCreate, setAptCreate] = useState("");
  const [ZIPCodeCreate, setZIPCodeCreate] = useState("");
  const [DirectionCreate, setDirectionCreate] = useState("");

  const [isDrawerOpenCountryNumber, setIsDrawerOpenCountryNumber] =
    useState(false);
  const [UpdateFillAll, setUpdateFillAll] = React.useState(false);

  return (
    <div
      style={{
        paddingTop: MyWidth <= 768 ? 0 : 50,
        marginBottom: MyWidth <= 768 ? 50 : 0,
      }}
    >
      {Modal1()}
      <div
        style={{
          display: "flex",
          //justifyContent: "center",
          flexDirection: "column",
          paddingLeft: MyWidth <= 768 ? "0%" : "10%",
        }}
      >
        {MyWidth <= 768 ? (
          <></>
        ) : (
          <>
            <p style={{ fontWeight: 500, fontSize: 25 }}>
              {t("profile.AddressBook")}
            </p>
          </>
        )}
        <p> </p>
        <div
          style={{
            flexDirection: MyWidth <= 768 ? "column" : "row",
            justifyContent: "space-between",
            width: "100%",
            display: "flex",
          }}
        >
          {loading ? (
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Lottie
                style={{ height: 40, width: 40 }}
                animationData={LottifileLoading}
              />
            </div>
          ) : (
            <>
              {data.length !== 0 ? (
                <div style={{ width: MyWidth <= 768 ? "100%" : "40%" }}>
                  {data.map((Address) => (
                    <div key={Address.id} style={{ paddingBottom: 50 }}>
                      <div
                        style={{
                          justifyContent: "space-between",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <a style={{ fontWeight: "500" }}>
                          {Address.firstName} {Address.lastName}
                        </a>
                        <div
                          onClick={() =>
                            handleSubmit(Address.id, Address.userId)
                          }
                          aria-label="controlled"
                          style={{
                            width: 24,
                            height: 24,
                            border: "2px solid black",
                            borderRadius: "50%",
                            position: "relative",
                            cursor: "pointer",
                          }}
                        >
                          {String(Address.id) === String(selectedUserId) && (
                            <div
                              style={{
                                width: 12,
                                height: 12,
                                backgroundColor: "black",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      {/* <div>
                        <a>
                          {Address.building}, {Address.apartment},{" "}
                          {Address.street}
                        </a>
                      </div> */}
                      <div>
                        {/* <a>
                          {Address.zipCode}, {Address.city}
                        </a> */}
                        <a>{Address.city}</a>
                      </div>
                      <div>
                        <a>
                          {t("profile.Phone")} {Address.phonenumber}
                        </a>
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const parts = Address.phonenumber.split(" ");
                            // Save before space in new const
                            const countryCode = parts[0]; // "+972"
                            // Save after space in new const
                            const localNumber = parts[1]; // "0527477128"
                            console.log(parts);
                            console.log(countryCode);
                            console.log(localNumber);

                            setFirstNameCreate(Address.firstName);
                            setLastNameCreate(Address.lastName);
                            setPhoneNumberCreate(localNumber);
                            setStreetCreate(Address.street);
                            setBuildingCreate(Address.building);
                            setAptCreate(Address.apartment);
                            setCityCreate({
                              label: Address.city,
                              value: Address.city,
                            });
                            setDirectionCreate(Address.direction);
                            setZIPCodeCreate(Address.zipCode);
                            setCountryPhoneNumberCreate({
                              label: countryCode,
                              value: countryCode,
                            });
                            setChooseIDForEdit(Address.id);
                          }}
                        >
                          {t("profile.edit")}
                        </a>
                        {String(selectedUserId) === String(Address.id) ? (
                          <></>
                        ) : (
                          <div
                            onClick={() => {
                              setIdOfDeleteAddress(Address.id);
                              setOpen1(true);
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={CloseImg}
                              //alt={title}
                              style={{
                                maxHeight: 18,
                                maxWidth: 18,
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          border: "0.2px solid #f4f4f5",
                          width: "100%",
                        }}
                      ></div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ width: "40%" }}>{t("profile.Emptylist")}</div>
              )}
            </>
          )}
          <div
            style={{
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              width: MyWidth <= 768 ? "100%" : "40%",
            }}
          >
            <>
              <div
                style={{
                  width: windowWidth <= 1024 ? "90%" : "100%",
                  paddingBottom: 40,
                }}
              >
                <div
                  style={{
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                  }}
                >
                  <p>
                    {ChooseIDForEdit === 0 ? (
                      <a style={{ fontWeight: "bold" }}>
                        {t("profile.Addanewaddress")}
                      </a>
                    ) : (
                      <>
                        <a>{t("profile.edit")}</a>
                      </>
                    )}
                  </p>
                </div>
                <TextField
                  id="standard-basic"
                  label={`${t("profile.Firstname")}*`}
                  variant="standard"
                  style={{
                    paddingBottom: 45,
                    width: "100%",
                    maxWidth: 500,
                  }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" },
                  }}
                  value={FirstNameCreate}
                  onChange={(e) => setFirstNameCreate(e.target.value)}
                  //error={FirstNameError} // Apply the error state to show red color
                />
                <TextField
                  id="standard-basic"
                  label={`${t("profile.Lastname")}*`}
                  variant="standard"
                  style={{
                    paddingBottom: 45,
                    width: "100%",
                    maxWidth: 500,
                  }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" },
                  }}
                  value={LastNameCreate}
                  onChange={(e) => setLastNameCreate(e.target.value)}
                  //error={LastNameError} // Apply the error state to show red color
                  //helperText={LastNameError ? "This field is required" : ""}
                />
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "35%",
                    }}
                  >
                    <Autocomplete
                      sx={{ width: "100%" }}
                      options={ArrayCountryPhoneNumbers}
                      getOptionLabel={(option) => option.label}
                      value={CountryPhoneNumberCreate}
                      onFocus={() => setIsDrawerOpenCountryNumber(true)} // Open drawer on focus
                      onBlur={() => setIsDrawerOpenCountryNumber(false)} // Close drawer on blur
                      onChange={(event, newValue) =>
                        setCountryPhoneNumberCreate(newValue)
                      }
                      PaperComponent={(props) => <StyledPaper {...props} />}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={`${t("profile.Countrynumber")}*`}
                          variant="standard"
                          style={{
                            paddingBottom: 45,
                            width: "100%",
                            maxWidth: 500,
                          }}
                          InputLabelProps={{
                            style: { opacity: 0.5, fontSize: "15px" },
                          }}
                          //error={CountryPhoneNumbersErr} // Apply the error state to show red color
                        />
                      )}
                    />
                  </div>
                  <div style={{ display: "flex", width: "60%" }}>
                    <TextField
                      id="standard-basic"
                      label={`${t("profile.Phone")}*`}
                      variant="standard"
                      style={{ paddingBottom: 45, width: "100%" }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" },
                      }}
                      InputProps={{
                        inputProps: {
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          style: {
                            // Remove arrows in all browsers
                            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                            MozAppearance: "textfield", // Firefox
                            appearance: "none", // Standard
                          },
                        },
                      }}
                      value={PhoneNumberCreate}
                      onChange={(e) =>
                        setPhoneNumberCreate(
                          e.target.value.replace(/[^0-9]/g, "")
                        )
                      } // Force numbers only
                      //error={PhoneNumberError}
                    />
                  </div>
                </div>
                <Autocomplete
                  options={Towns}
                  getOptionLabel={(option) => option.label}
                  value={CityCreate}
                  open={isDrawerOpen} // Controlled open state
                  onOpen={() => setIsDrawerOpen(true)}
                  onClose={() => setIsDrawerOpen(false)}
                  onChange={(event, newValue) => {
                    if (newValue && newValue.isCustomOption) {
                      console.log("Custom town option selected");
                    } else {
                      setCityCreate(newValue);
                      const foundObject = CheckTowns.find(
                        (obj) => obj.town === newValue?.value
                      );
                      console.log(foundObject?.direction);
                      setDirectionCreate(foundObject?.direction);
                    }

                    setIsDrawerOpen(false); // Close when value is selected
                  }}
                  PaperComponent={(props) => <StyledPaper {...props} />}
                  noOptionsText={
                    <div
                      style={{
                        cursor: "pointer",
                        color: "#1976d2",
                        padding: "8px 16px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent event bubbling
                        console.log("Don't find your town clicked");
                      }}
                    >
                      Don't find your town? Click here
                      {isDrawerOpen && ( // Only show when drawer is open
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {TheDirection.map((item, index) => (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent event bubbling
                                setCityCreate({
                                  label: item.label,
                                  value: item.value,
                                });
                                setDirectionCreate(item.value);
                                setIsDrawerOpen(false); // Explicitly close
                              }}
                              style={{
                                color: "black",
                                cursor: "pointer",
                                backgroundColor:
                                  hoveredIndex === index
                                    ? "#f0f0f0"
                                    : "transparent",
                                //padding: "8px",
                                borderRadius: "4px",
                                transition: "background-color 0.3s ease",
                              }}
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                            >
                              <a style={{ fontSize: 14 }}>{item.label}</a>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`${t("profile.City")}*`}
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" },
                      }}
                      //error={CityError}
                    />
                  )}
                />
                {/* <TextField
                  id="standard-basic"
                  label={`${t("profile.Street")}*`}
                  variant="standard"
                  style={{
                    paddingBottom: 45,
                    width: "100%",
                    maxWidth: 500,
                  }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                  }}
                  value={StreetCreate} // Bind the state value to the TextField
                  onChange={(e) => setStreetCreate(e.target.value)} // Update state on input change
                  //error={StreetError} // Apply the error state to show red color
                /> */}
                {/* <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    id="standard-basic"
                    label={t("profile.Building")}
                    variant="standard"
                    style={{
                      paddingBottom: 45,
                      width: "30%",
                      maxWidth: 500,
                    }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                    }}
                    value={BuildingCreate} // Bind the state value to the TextField
                    onChange={(e) => setBuildingCreate(e.target.value)} // Update state on input change
                  />
                  <TextField
                    id="standard-basic"
                    label={t("profile.Apt")}
                    variant="standard"
                    style={{
                      paddingBottom: 45,
                      width: "30%",
                      maxWidth: 500,
                    }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                    }}
                    value={AptCreate} // Bind the state value to the TextField
                    onChange={(e) => setAptCreate(e.target.value)} // Update state on input change
                  />
                  <TextField
                    id="standard-basic"
                    label={`${t("profile.ZIPCode")}*`}
                    variant="standard"
                    style={{
                      paddingBottom: 45,
                      width: "30%",
                      maxWidth: 500,
                    }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                    }}
                    value={ZIPCodeCreate} // Bind the state value to the TextField
                    onChange={(e) => setZIPCodeCreate(e.target.value)} // Update state on input change
                  />
                </div> */}
                <div
                  style={{
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                  }}
                >
                  <button
                    style={{
                      borderWidth: 0,
                      backgroundColor: "white",
                      border: "1px solid black",
                      color: "black",
                      marginTop: 45,
                      height: 50,
                      width: "25%",
                      maxWidth: 150,
                      minWidth: 120,
                    }}
                    onClick={() => {
                      {
                        ChooseIDForEdit === 0
                          ? CreateNewAddress()
                          : UpdateAddressFunc();
                      }
                    }}
                  >
                    {t("profile.Save")}
                  </button>
                  {UpdateFillAll ? (
                    <>
                      <a style={{ fontSize: 14, color: "red" }}>
                        {t("profile.Pleasefillinallrequiredfields")}
                      </a>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
